export default "__VITE_ASSET__BDoK_FPQ__"